// extracted by mini-css-extract-plugin
export var description = "description-module--description--QUqRt";
export var person = "description-module--person--2WY+2";